/**
 * CRM REST API origin — derived from the single {@link BACKEND_URL} in `src/config/backend.ts`.
 */
import { getBackendOrigin } from './backend';
export { DEFAULT_BACKEND_URL as DEFAULT_CRM_API_ORIGIN } from './backend';
/** CRM API host, or empty when using same-origin `/api/...` (webpack dev-server proxy). */
export const getCrmApiOrigin = getBackendOrigin;
/** Base path for the fetch-based ApiClient (`/api` + endpoint). */
export function getCrmApiBasePath() {
    const origin = getCrmApiOrigin();
    return origin ? `${origin}/api` : '/api';
}
/**
 * Rewrites relative `/api/...` to the backend origin unless already absolute.
 */
export function resolveCrmApiRequestUrl(url) {
    if (!url || /^https?:\/\//i.test(url)) {
        return url;
    }
    const origin = getCrmApiOrigin();
    if (!origin) {
        return url;
    }
    const path = url.startsWith('/') ? url : `/${url}`;
    if (path.startsWith('/api/') ||
        path === '/api' ||
        path.startsWith('/user/')) {
        return `${origin}${path}`;
    }
    return url;
}
